import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { BorderStyleType } from 'types/styles';

export const borderStyleOptions: SettingsRadioItem<BorderStyleType>[] = [
  { value: 'solid', label: 'Сплошная' },
  { value: 'dashed', label: 'Пунктирная' },
  { value: 'dotted', label: 'Точками' },
];
